import React from 'react'
import { useFormContext } from 'react-hook-form'
import ReactTooltip from 'react-tooltip'
import { connect } from 'react-redux'

import { InputField, NumberInput, CurrencyValueInput } from '../Input'

import Info from 'assets/svg/info.svg'

import {
    ProductTooltip,
    ProductTooltipOthers,
    ProductTooltipAliRef
} from './tooltips'

import { groups } from 'constants/pod-groups'

import { withMobile } from 'utils/mobile'

import {
    openProductAliRefModal,
    openProductModal,
    openProductOthersModal
} from 'store/actions/home'

import { FormProductRow, Icon, InputLabel } from './ProductFormLayout.style'
import { Name, ImageTooltip } from './ProductFormItem.style'

const ProductFormItem = ({
    mobile,
    product,
    group,
    withTooltip = false,
    labelColor,
    openProductModal,
    openProductAliRefModal,
    openProductOthersModal,
    className
}) => {
    const { trigger, watch } = useFormContext()

    const name = `groups.${group.type}`

    const openModal = () => {
        if (group.type === groups.OUTROS) {
            openProductOthersModal()
            return
        }

        if (group.type === groups.ALIMENTACAO_REFEICAO) {
            openProductAliRefModal()
            return
        }

        openProductModal(group)
    }

    return (
        <FormProductRow className={className}>
            <Icon>
                <img
                    src={group.icon}
                    alt={`Icone ${product.name} ${group.desc}`}
                />
            </Icon>
            <Name>
                <span>{group.desc}</span>
                {withTooltip && (
                    <ImageTooltip
                        src={Info}
                        alt="info"
                        data-testid="clickable-container"
                        data-for={`${group.type}Tooltip`}
                        data-tip="whatIs"
                        onClick={openModal}
                    />
                )}
            </Name>
            <div>
                <InputLabel
                    labelColor={labelColor}
                    htmlFor={`${group.type}CardQuantity`}
                >
                    Qtde colaboradores
                </InputLabel>
                <InputField
                    as={NumberInput}
                    tooltipErrors
                    id={`${group.type}CardQuantity`}
                    name={`${name}.cardQuantity`}
                    onChange={() => {
                        trigger()
                        trigger('sumCardQuantity')
                    }}
                    type="tel"
                    errorColor={product.errorColor}
                    aria-label={`Quantidade de cartões ${product.name}`}
                    mask={[{ mask: Number, min: 0, max: 50000 }]}
                    unmask="typed"
                    className="card-quantity"
                />
            </div>
            <div>
                <InputLabel
                    labelColor={labelColor}
                    htmlFor={`${group.type}MonthlyValue`}
                >
                    Valor Mensal por colab.
                </InputLabel>
                <InputField
                    as={CurrencyValueInput}
                    tooltipErrors
                    decimalSeparator=","
                    thousandSeparator="."
                    prefix="R$ "
                    inputType="tel"
                    maxLength={13}
                    allowEmpty={true}
                    id={`${group.type}MonthlyValue`}
                    name={`${name}.monthlyValue`}
                    onChange={() => {
                        trigger(`${name}.monthlyValue`)
                        trigger(`${name}.cardQuantity`)
                    }}
                    defaultValue={watch(`${name}.monthlyValue`) ?? ''}
                    type="tel"
                    errorColor={product.errorColor}
                    aria-label="Valor mensal por cartão"
                    className="card-value"
                />
            </div>
            {withTooltip && !mobile && (
                <>
                    {![groups.ALIMENTACAO_REFEICAO, groups.OUTROS].includes(
                        group.type
                    ) && (
                        <ReactTooltip
                            id={`${group.type}Tooltip`}
                            effect="solid"
                            place="bottom"
                            getContent={() =>
                                ProductTooltip({ product, group })
                            }
                        />
                    )}
                    <ReactTooltip
                        id={`${groups.OUTROS}Tooltip`}
                        effect="solid"
                        place="bottom"
                        getContent={ProductTooltipOthers}
                    />
                    <ReactTooltip
                        id={`${groups.ALIMENTACAO_REFEICAO}Tooltip`}
                        effect="solid"
                        place="bottom"
                        getContent={ProductTooltipAliRef}
                    />
                </>
            )}
        </FormProductRow>
    )
}

const mapDispatchToProps = (dispatch) => ({
    openProductModal: (group) => dispatch(openProductModal(group)),
    openProductAliRefModal: () => dispatch(openProductAliRefModal()),
    openProductOthersModal: () => dispatch(openProductOthersModal())
})

export default withMobile(connect(null, mapDispatchToProps)(ProductFormItem))
